import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LeadDTO } from '../models/lead.model';
import { Observable } from 'rxjs';
import { BACKEND_URI } from "../config/config-vars";

@Injectable({
  providedIn: 'root'
})
export class LeadService {
  private readonly BASE_URL = `${BACKEND_URI}/api/leads`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<LeadDTO[]> {
    return this.http.get<LeadDTO[]>(this.BASE_URL);
  }
create(dto: LeadDTO): Observable<LeadDTO> {
  console.log('Sending to backend:', dto);  // ✅ Add this
  return this.http.post<LeadDTO>(this.BASE_URL, dto);
}


  update(id: string, dto: LeadDTO): Observable<LeadDTO> {
    return this.http.put<LeadDTO>(`${this.BASE_URL}/${id}`, dto);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.BASE_URL}/${id}`);
  }

    getLeadCount(): Observable<number> {
    return this.http.get<number>(`${this.BASE_URL}/count`);
  }

  getAllLeads(): Observable<LeadDTO[]> {
    return this.http.get<LeadDTO[]>(`${this.BASE_URL}`);
  }

  
}
